import { render } from "./Header.vue?vue&type=template&id=43421463&scoped=true"
import script from "./Header.vue?vue&type=script&lang=ts"
export * from "./Header.vue?vue&type=script&lang=ts"

import "./Header.vue?vue&type=style&index=0&id=43421463&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-43421463"

export default script